<template>
  <div class="chart flex-column flex-justify-start flex-align-start" :class="[{'card-gap': gap}]">
    <div class="chart-head flex-row flex-justify-start flex-align-start">(制冷)时长</div>
    <div class="chart-contain flex-row flex-justify-center flex-align-start">
      <div id="coldref" class="chart-area"></div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';

export default {
  name: 'ColdChart',
  props: {
    gap: {
      type: Boolean,
      default: true
    },
    cold: {
      type: Object,
      default: () => ({
        thiscold: [],
        lastcold: []
      })
    }
  },
  data() {
    return {
      coldChart: null
    }
  },
  watch: {
    cold: {
      handler() {
        this.$nextTick(() => {
          this.initChart()
        })
      },
      deep: true
    },
  },
  beforeDestroy() {
    if(this.coldChart != null) {
      this.coldChart.dispose()
      this.coldChart = null
    }
  },
  methods: {
    initChart() {
      var chartDom = document.getElementById('coldref')
      if(!chartDom) {
        return
      }
      if (!this.coldChart) {
        this.coldChart = echarts.init(chartDom);
      }
      var option = {
        tooltip: {
          trigger: 'axis',
          extraCssText: 'text-align: left;',
          axisPointer: {
            type: 'none'
          }
        },
        legend: {
          data: ['今年时长', '去年时长']
        },
        xAxis: [
          {
            type: 'category',
            data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '时长 / 小时',
            // min: 0,
            // max: 1500000,
            // interval: 300000,
            axisLabel: {
              formatter: '{value}'
            }
          }
        ],
        series: [
          {
            name: '今年时长',
            type: 'line',
            tooltip: {
              valueFormatter: function (value) {
                return value + '小时';
              }
            },
            itemStyle: {
              color: '#08affe'
            },
            data: this.cold.thiscold
          },
          {
            name: '去年时长',
            type: 'line',
            tooltip: {
              valueFormatter: function (value) {
                return value + '小时';
              }
            },
            itemStyle: {
              color: '#6bc26b'
            },
            data: this.cold.lastcold
          }
        ]
      }
      this.coldChart.setOption(option)
    }
  }
}
</script>

<style scoped>
.chart {
  width: 49.5%;
  background-color: #fff;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
}
.card-gap {
  margin-right: 1%;
}
.chart-head {
  font-family: 'Arial';
  font-size: 18px;
  margin-left: 20px;
  margin-top: 10px;
}
.chart-area {
  min-width: 800px;
  min-height: 400px;
}
.chart-contain {
  width: 100%;
  overflow: hidden;
}
</style>
